import React from 'react';

var ArrowIcon = function ArrowIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "\u7F16\u7EC4 8"), /*#__PURE__*/React.createElement("g", {
    id: "\u5BFC\u822A",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u6D45\u8272-PC\u5BFC\u822A-\u767B\u5F55\u540E",
    transform: "translate(-1354, -25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u7F16\u7EC4-4",
    transform: "translate(32, 14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u7F16\u7EC4-8",
    transform: "translate(1322, 11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62",
    x: "0",
    y: "0",
    width: "10",
    height: "10"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\u8DEF\u5F84-3",
    stroke: "#091221",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "1.45243696 3.50317465 5 7.05073769 8.54756304 3.50317465"
  }))))));
};
var ArrowIcon2 = function ArrowIcon2() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "icon-left"), /*#__PURE__*/React.createElement("g", {
    id: "page",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u951A\u70B9-\u5C45\u4E2D",
    transform: "translate(-270, -234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigation",
    transform: "translate(0, 216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u66F4\u591A",
    transform: "translate(248, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-left",
    transform: "translate(22, 18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62",
    x: "0",
    y: "0",
    width: "12",
    height: "12"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\u8DEF\u5F84-3",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(6, 6) scale(-1, 1) rotate(-90) translate(-6, -6)",
    points: "2 4 6 8 10 4"
  })))))));
};

export { ArrowIcon, ArrowIcon2 };
